// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedPartOfSpeech {
  'Adjectival Noun': {"enum_constant":"Adjectival Noun","code":"AN"};
  Adjective: {"enum_constant":"Adjective","code":"A"};
  Adverb: {"enum_constant":"Adverb","code":"D"};
  'Auxiliary Verb': {"enum_constant":"Auxiliary Verb","code":"VA"};
  Conjunction: {"enum_constant":"Conjunction","code":"J"};
  Determiner: {"enum_constant":"Determiner","code":"DT"};
  Interjection: {"enum_constant":"Interjection","code":"I"};
  Interrogative: {"enum_constant":"Interrogative","code":"INT"};
  Noun: {"enum_constant":"Noun","code":"N"};
  'Noun Abbreviation': {"enum_constant":"Noun Abbreviation","code":"NA"};
  Particle: {"enum_constant":"Particle","code":"PL"};
  'Phrasal Verb': {"enum_constant":"Phrasal Verb","code":"PH"};
  Phrase: {"enum_constant":"Phrase","code":"E"};
  Preposition: {"enum_constant":"Preposition","code":"PR"};
  Pronoun: {"enum_constant":"Pronoun","code":"NR"};
  'Proper Noun': {"enum_constant":"Proper Noun","code":"NP"};
  Verb: {"enum_constant":"Verb","code":"V"};
  'Verbal Noun': {"enum_constant":"Verbal Noun","code":"VN"};
}

export type PartOfSpeechId = keyof IParsedPartOfSpeech;
export type PartOfSpeechData = IParsedPartOfSpeech[PartOfSpeechId];
const data: PartOfSpeechData[] = [{"enum_constant":"Adjectival Noun","code":"AN"},{"enum_constant":"Adjective","code":"A"},{"enum_constant":"Adverb","code":"D"},{"enum_constant":"Auxiliary Verb","code":"VA"},{"enum_constant":"Conjunction","code":"J"},{"enum_constant":"Determiner","code":"DT"},{"enum_constant":"Interjection","code":"I"},{"enum_constant":"Interrogative","code":"INT"},{"enum_constant":"Noun","code":"N"},{"enum_constant":"Noun Abbreviation","code":"NA"},{"enum_constant":"Particle","code":"PL"},{"enum_constant":"Phrasal Verb","code":"PH"},{"enum_constant":"Phrase","code":"E"},{"enum_constant":"Preposition","code":"PR"},{"enum_constant":"Pronoun","code":"NR"},{"enum_constant":"Proper Noun","code":"NP"},{"enum_constant":"Verb","code":"V"},{"enum_constant":"Verbal Noun","code":"VN"}];
export default data;
